import { createStateSelectorHook } from 'src/lib/sweetState';

import { MainStore } from '../../store/main';

const useMainState = createStateSelectorHook(MainStore, ['selectedWorkspaceId', 'pendingDecision']);

export const useViewState = () => {
  const mainState = useMainState();

  return { ...mainState };
};
